import { Injectable, inject } from '@angular/core';

import { BaseEntityRepository } from '../../core/abstractions/base-entity.repository';
import { AllocationModel } from '../../models/allocation.model';
import { RepositoryService } from '../repository.service';
import { RepositoriesConfig } from '../../core/utils/repositories.config';
import { DbContext } from '../../core/utils/db-context';

@Injectable({
    providedIn: 'root'
})
export class AllocationsRepository extends BaseEntityRepository<AllocationModel> {

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const repositoryService = inject(RepositoryService);

        super(repositoryService);
        this.config = RepositoriesConfig.repositories.find(r => r.tableName === DbContext.Allocations);
    }
}
